var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalClose2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2932 18.7103C11.4807 18.8978 11.735 19.0031 12.0002 19.0031C12.2653 19.0031 12.5196 18.8978 12.7072 18.7103L15.0002 16.4173L17.2932 18.7103C17.4818 18.8925 17.7344 18.9933 17.9966 18.991C18.2588 18.9887 18.5096 18.8836 18.695 18.6982C18.8804 18.5127 18.9855 18.2619 18.9878 17.9997C18.9901 17.7375 18.8893 17.4849 18.7072 17.2963L16.4142 15.0033L18.7072 12.7103C18.8893 12.5217 18.9901 12.2691 18.9878 12.0069C18.9855 11.7447 18.8804 11.4939 18.695 11.3085C18.5096 11.1231 18.2588 11.0179 17.9966 11.0157C17.7344 11.0134 17.4818 11.1142 17.2932 11.2963L15.0002 13.5893L12.7072 11.2963C12.5186 11.1142 12.2659 11.0134 12.0038 11.0157C11.7416 11.0179 11.4907 11.1231 11.3053 11.3085C11.1199 11.4939 11.0148 11.7447 11.0125 12.0069C11.0102 12.2691 11.111 12.5217 11.2932 12.7103L13.5862 15.0033L11.2932 17.2963C11.1057 17.4839 11.0004 17.7382 11.0004 18.0033C11.0004 18.2685 11.1057 18.5228 11.2932 18.7103Z",
    fill: "#99A4A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#EFF5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose2);
export default __webpack_public_path__ + "static/media/modalClose2.5e78460e7f795fcde08c66993cef9805.svg";
export { ForwardRef as ReactComponent };